import { Component, OnInit } from '@angular/core';
import { BasicList } from '../../../../classes';
import { VOLUME_DISCOUNT_UNITS, MERCHANT_TYPE, PAYMENT_TYPE, USER_ROLES } from '../../../../enums';
import { BsModalService } from 'ngx-bootstrap';
import { ProductsService } from '../../../../services';
import { ToastrService } from 'ngx-toastr';
import { Event } from '../../../../interfaces';
import { VolumeDiscountRateApi } from '../../../../../assets/js/lb-sdk/services/custom/VolumeDiscountRate';
import { VolumeDiscountRateFormComponent } from './volume-discount-rate-form/volume-discount-rate-form.component';
import { AgentProfileComponent } from '../../../agents/agent-profile/agent-profile.component';
import { LoopBackAuth } from '../../../../../assets/js/lb-sdk';

@Component({
  selector: 'app-volume-discount-rates',
  templateUrl: './volume-discount-rates.component.html',
  styleUrls: ['./volume-discount-rates.component.css']
})
export class VolumeDiscountRatesComponent extends BasicList {
  VOLUME_DISCOUNT_UNITS: typeof VOLUME_DISCOUNT_UNITS = VOLUME_DISCOUNT_UNITS;
  USER_ROLES: typeof USER_ROLES = USER_ROLES;

  constructor(
    private volumeDiscountRateApi: VolumeDiscountRateApi,
    private modalService: BsModalService,
    public productsService: ProductsService,
    private loopBackAuth: LoopBackAuth,
    private toast: ToastrService
  ) {
    super();
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'partnerId', placeholder: 'Merchant Id' },
        { name: 'productType', placeholder: 'Product Type', optionsFunction: () => {
          return (this.productsService.getProductTypes() || [])
            .map(productType => {
              return {
                value: productType.name,
                description: productType.description
              };
            });
        } },
        { name: 'merchantType', placeholder: 'Merchant Type', options: MERCHANT_TYPE },
        { name: 'paymentType', placeholder: 'Payment Type', options: PAYMENT_TYPE }
      ],
      filters: {}
    };
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.settings = {
      createComponent: VolumeDiscountRateFormComponent,
      api: this.volumeDiscountRateApi,
      ModalService: this.modalService
    };
  }

  modify(data) {
    const { id, partnerId, productType, merchantType, paymentType, unit, minimum, discount } = data;
    this.edit({
      id,
      partnerId: partnerId,
      productType: this.productsService.getProductTypeByName(productType),
      merchantType,
      paymentType,
      discount,
      unit,
      minimum
    });
  }

  userDetails(data): void {
    const userModal = this.settings.ModalService
      .show(AgentProfileComponent, {
        initialState: { data: { merchantId: data.partnerId } }
      });
    const subscription = this.modalService.onHidden
      .subscribe(() => {
        if (userModal.content) {
          if (userModal.content.result) {
            // DO SOMETHING
          } else {
            // DO SOMETHING
          }
        }
        subscription.unsubscribe();
      });
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('Volume discount rate successfully created', 'Volume Discount Rate');
        this.getList();
        break;
      case 'editModal:completed':
        this.toast.success('Volume discount rate successfully updated', 'Volume Discount Rate');
        this.getList();
        break;
      case 'delete:success':
        this.toast.success('Volume discount rate successfully deleted', 'Volume Discount Rate');
        this.getList();
        break;
      case 'initialized':
        this.getList();
        break;
    }
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
